import { useAppRouter } from '@/common/route/useAppRouter';
import { useCrudActions } from '@/common/view/useCrudActions';
import { useAppStore } from '@/modules/apps/store';
import { ROUTE_NAME_NEWS } from '@/modules/news/router';
import { newsService } from '@/services/news';
import { useVuelidate } from '@vuelidate/core';
import { storeToRefs } from 'pinia';
import { useMixins } from './mixins';

export function useNewsAdd() {
    const router = useAppRouter();

    const { appId, appSelectOptions } = storeToRefs(useAppStore());

    const { model, validations, fetch } = useMixins();
    const v$ = useVuelidate(validations, model);

    // in case: clone item
    const fetchItem = async () => {
        if (model.id) {
            await fetch();
            model.forAppId = appId.value;
        }
    };

    const actions = {
        create: useCrudActions().excuteAndNotify({
            validator: v$,
            request: () => {
                const startTime = model.startTime?.getTime() ?? null;
                const endTime = model.endTime?.getTime() ?? null;
                const publishTime = model.publishTime.getTime();
                const unpublishTime = model.unpublishTime.getTime();
                const fromRegisterTime = model.fromRegisterTime?.getTime() ?? null;
                const toRegisterTime = model.toRegisterTime?.getTime() ?? null;

                let target = null;
                if (model.targetType == 0) {
                    target = 'link:' + model.target;
                } else if (model.targetType == 1) {
                    target = 'popup:' + model.target;
                } else if (model.targetType == 2) {
                    target = 'deeplink:' + model.target;
                }

                return newsService.create(
                    model.name,
                    model.id,
                    model.forAppId,
                    target,
                    startTime,
                    endTime,
                    publishTime,
                    unpublishTime,
                    fromRegisterTime,
                    toRegisterTime,
                    model.imageFile,
                    model.thumbnailFile
                );
            },
            onError: () => router.push({ name: ROUTE_NAME_NEWS.INDEX })
        })
    };

    return { model, v$, appSelectOptions, fetchItem, actions };
}
